import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { useErrorSnackbar } from 'hooks/useErrorSnackbar';
import { OverlayContext } from 'contextProviders/OverlayContext';
import { exportAnalysisToFile } from 'utils/exportAnalysisUtil';
import { IGroupAnalysisDetail } from 'interfaces/Pricelist/IGroupAnalysisDetail';
import { IPricelistMasterDetailProps } from 'interfaces/Pricelist/IPricelistMasterDetailProps';
import './GroupAnalysis.scss';

const GroupAnalysis = (props: IPricelistMasterDetailProps) => {
  const { setShowLoadingOverlay } = useContext(OverlayContext);
  const showError = useErrorSnackbar();
  const { getGroupAnalysisInfo, getAnalysisExcelDownload } = PricelistApis();
  const [error, setError] = useState('');
  const [groupAnalysisInfo, setGroupAnalysisInfo] = useState<IGroupAnalysisDetail | undefined>();

  useEffect(() => {
    getGroupAnalysisInfo(props.analysis, props.matrix)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setGroupAnalysisInfo(data);
        }
      })
      .catch((e) => setError(e));
  }, [props, getGroupAnalysisInfo]);

  const exportAnalysis = useCallback(() => {
    if (!groupAnalysisInfo) {
      return;
    }

    exportAnalysisToFile({
      analysis: groupAnalysisInfo.Analysis,
      matrix: groupAnalysisInfo.Matrix,
      setShowLoadingOverlay,
      setDownloadErrorSnackbar: showError,
      getAnalysisExcelDownload
    });
  }, [groupAnalysisInfo, showError, setShowLoadingOverlay, getAnalysisExcelDownload]);

  return (
    <Box className="groupAnalysisInfo">
      {error && !groupAnalysisInfo ? <Box className="errorBox">{error}</Box> : null}
      {!error && !groupAnalysisInfo ? <Box><h2>Loading Group Analysis Info...</h2></Box> : null}
      {groupAnalysisInfo ?
      <>
        <Box>
          <h2>Analysis Performed by</h2>
          <p>{groupAnalysisInfo.Facility}</p>
        </Box>
        {groupAnalysisInfo.EntryInfo?.length > 0 ? (
          <Box>
            <h2>Additional Information</h2>
            {groupAnalysisInfo.EntryInfo.map((m) => (
              <p key={m.EntryInfo}>{m.EntryInfo}</p>
            ))}
          </Box>
        ) : null}
      </> : null }

      <Box>
        <Button className="btnAnalysisExport" onClick={exportAnalysis}>Export Analytes</Button>
      </Box>
    </Box>
  );
};

export default GroupAnalysis;
